/*
 * GrowthBook Feature Flags
 * Configuration for each flag can be found at: https://flagging.marty.zappos.com/features/<feature-name>
 */

export const FEATURE_SITE_REDESIGN = 'marty.site-redesign';
export const FEATURE_PTCT = 'ptct';
export const FEATURE_MAFIA_AKAMAI = 'marty.mafia.akamai'; // [M]afia behind [Aka]mai
export const FEATURE_RECOMMENDATIONS_SEARCH = 'marty.recommendations.search';
export const FEATURE_CONTENT_SQUARE_KILLSWITCH = 'marty.content.square';
export const FEATURE_PERCENT_DISCOUNT_SORT = 'search.ab.percent.discount.sort';
export const FEATURE_GOODS_LABEL_ENDPOINT = 'marty.goods.label.endpoint';
